import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function DollarDiscount({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>DollarDiscount</title>
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="9.79883"
        cy="9.7986"
        r="0.791538"
        transform="rotate(45 9.79883 9.7986)"
        fill={color ?? 'currentColor'}
      />
      <circle
        cx="14.2012"
        cy="14.2014"
        r="0.791538"
        transform="rotate(45 14.2012 14.2014)"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M9.76067 14.2388L14.2383 9.76123"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
